// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"fef1fa01","298":"66a38d2d","964":"b43d888e"}[chunkId] + ".chunk.css";
};